if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.selectors = {
          form: "form",
          inputId: "[name=id]",
          submitButton: '[name="add"]',
          errorWrapper: ".f-product-form__error-message-wrapper",
          customFields: ["[data-product-custom-field]"],
        };

        this.domNodes = queryDomNodes(this.selectors, this);

        this.form = this.domNodes.form;
        this.submitButton = this.domNodes.submitButton;
        this.domNodes.inputId.disabled = false;
        this.Notification = window.FoxTheme.Notification;
        this.notificationType = this.dataset.notificationType;
        this.customFields = document.querySelectorAll(
          this.selectors.customFields,
        );
        this.cartDrawer = document.querySelector("cart-drawer");
        this.mainCart = document.querySelector("cart-items");
        this.type = this.dataset.type;

        this.errorWrapper =
          this.type === "product-card"
            ? this.closest(".product-card")
            : this.domNodes.errorWrapper;

        if (!this.form) return;

        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
      }

      validateForm(form) {
        const missingFields = [];
        if (!form) return missingFields;
        const fieldSelectors =
          '[data-product-custom-field] [name][required]:not([hidden]):not([type="hidden"])';
        const requiredFields = form.querySelectorAll(fieldSelectors);
        requiredFields.forEach((field) => {
          field.classList.remove("form-control--warning");
          if (field.type === "radio") {
            const buttons = form.querySelectorAll(
              `input[name="${field.name}"]`,
            );
            const selected = Array.from(buttons).some((btn) => btn.checked);
            if (!selected) {
              missingFields.push(field);
              field.classList.add("form-control--warning");
            }
          } else if (!field.value) {
            missingFields.push(field);
            field.classList.add("form-control--warning");
          }
        });
        return missingFields;
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        const missing = this.validateForm(
          this.form.closest(".f-product-single__blocks"),
        );

        if (missing && missing.length > 0) {
          return this.Notification.show({
            target: this.domNodes.errorWrapper,
            method: "appendChild",
            type: "warning",
            message: window.FoxThemeStrings.requiredField,
          });
        }

        if (this.submitButton.classList.contains("btn--loading")) return;

        // Point d'extension (fiches plaque, src/js/modules/pdp-guarantee.js) : une fois le
        // formulaire validé, un module peut retenir l'ajout (ex. pop-up de garantie) puis le
        // relancer via proceed(extra), en ajoutant des lignes dans la MÊME requête /cart/add.js.
        const gate = this.form.cartAddGate;
        if (typeof gate === "function") {
          gate({
            submitButton: this.submitButton,
            proceed: (extra) => this.addToCart(extra),
          });
          return;
        }

        this.addToCart();
      }

      // FormData du formulaire produit -> corps /cart/add.js "items" : la ligne du formulaire en
      // premier (toutes ses properties conservées, ex. app Zepto), puis les lignes supplémentaires.
      // JSON, sauf si le formulaire contient un fichier (upload) : multipart "items[][…]" alors.
      buildItemsBody(formData, extra) {
        const formItem = { properties: {} };
        const rest = {};
        let hasFile = false;
        for (const [key, value] of formData.entries()) {
          if (value instanceof File && value.name) hasFile = true;
          const property = key.match(/^properties\[(.*)\]$/);
          if (property) formItem.properties[property[1]] = value;
          else if (key === "id" || key === "quantity" || key === "selling_plan") {
            if (value !== "") formItem[key] = parseInt(value, 10);
          }
          else rest[key] = value;
        }
        Object.assign(formItem.properties, extra.formItemProperties || {});
        if (!formItem.quantity) formItem.quantity = 1;
        const items = [formItem, ...(extra.items || [])];

        if (!hasFile) {
          const body = { items };
          const sections = formData.getAll("sections").join(",");
          if (sections) body.sections = sections;
          if (rest.sections_url) body.sections_url = rest.sections_url;
          return { body: JSON.stringify(body), json: true };
        }

        const multipart = new FormData();
        items.forEach((item) => {
          multipart.append("items[][id]", item.id);
          multipart.append("items[][quantity]", item.quantity || 1);
          if (item.selling_plan) multipart.append("items[][selling_plan]", item.selling_plan);
          Object.entries(item.properties || {}).forEach(([name, value]) => {
            multipart.append(`items[][properties][${name}]`, value);
          });
        });
        formData.getAll("sections").forEach((value) => multipart.append("sections", value));
        if (rest.sections_url) multipart.append("sections_url", rest.sections_url);
        return { body: multipart, json: false };
      }

      // extra (facultatif) : { items: [{ id, quantity, selling_plan, properties }],
      // formItemProperties: {…} } — cf. cartAddGate ci-dessus.
      addToCart(extra) {
        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("btn--loading");

        const config = {
          method: "POST",
          headers: {
            Accept: "application/javascript",
            "X-Requested-With": "XMLHttpRequest",
          },
        };

        const formData = new FormData(this.form);

        if (this.cartDrawer) {
          formData.append(
            "sections",
            this.cartDrawer.getSectionsToRender().map((section) => section.id),
          );
        }

        if (this.mainCart) {
          formData.append(
            "sections",
            this.mainCart
              .getSectionsToRender()
              .map((section) => section.section),
          );
        }

        if (this.mainCart || this.cartDrawer) {
          formData.append("sections_url", window.location.pathname);
        }

        config.body = formData;
        if (extra && ((extra.items && extra.items.length) || extra.formItemProperties)) {
          const { body, json } = this.buildItemsBody(formData, extra);
          config.body = body;
          if (json) config.headers = { ...config.headers, "Content-Type": "application/json" };
        }
        const { FoxThemeSettings, FoxThemeStrings } = window;
        fetch(`${FoxThemeSettings.routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              window.FoxThemeEvents.emit(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.description,
                message: response.message,
              });
              this.error = true;
              return this.Notification.show({
                target:
                  this.notificationType === "toast"
                    ? document.body
                    : this.errorWrapper,
                method: "appendChild",
                type: "warning",
                message: response.description || response.message,
                last: 3000,
                sticky: this.notificationType === "toast",
              });
            }

            if (
              !FoxThemeSettings.cart.openDrawerWhenAdded ||
              FoxThemeSettings.cart.cartType === "page"
            ) {
              this.Notification.show({
                target: this.errorWrapper,
                method: "appendChild",
                type: "success",
                message: FoxThemeStrings.item_added,
                last: 3000,
                sticky: this.notificationType === "toast",
              });
            }
            if (FoxThemeSettings.cart.cartType === "page") {
              FoxThemeCartHelpers.getState().then((state) => {
                // FoxThemeNestedCart n'est chargé que via cart-drawer.liquid/main-cart-items.liquid ;
                // repli sur item_count si absent sur cette page (ex. réglage cart_type "page" sans
                // drawer), plutôt que de planter.
                const count = window.FoxThemeNestedCart
                  ? window.FoxThemeNestedCart.countTopLevelLines(state.items)
                  : state.item_count;
                FoxThemeCartHelpers.updateCartCount(count);
              });
            }

            this.error = false;
            window.FoxThemeEvents.emit(`ON_ITEM_ADDED`, response);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("btn--loading");
            this.submitButton.removeAttribute("aria-disabled");
          });
      }
    },
  );
}
